import type { Page } from '@zotlo-shared/types/model';
import { useSiteDataOnClient } from '@/composables/useSiteDataOnClient';
import { GTM, GA4 } from '@/utils/integrations';

export function useLanding(page: Ref<Page>) {
  const { siteData, isPreview } = useSiteDataOnClient()

  const pageData = ref({
    docLinks: useDocLinks(),
    countryCode: siteData.value?.countryCode,
  })

  function homepageClick () {
    function clickEvent(event: any) {
      if (!siteData.value || isPreview.value) return false;

      GTM.push({
        event: 'customClick',
        clickCategory: 'Homepage',
        clickName: event.target.innerText
      });

      GA4.gtag('event', 'customClick', {
        clickCategory: 'Homepage',
        clickName: event.target.innerText
      })
    }

    const buttons = document.querySelectorAll('.tw-element-button, a[href]:not([href="#"]):not([href=""])');
    for (const button of buttons) {
      button.addEventListener('click', clickEvent);
    }
  }

  onMounted(() => {
    homepageClick()
  })

  return { page, pageData };
}
